(function () {
  var DEFAULT_API_URL = 'https://script.google.com/macros/s/AKfycbxg0LYrR2U0zq6OryMzEsG1Klw5nEVfd_-EYxzpixUtTUCwNoMhxRI6v4yhmorl0ey81Q/exec';

  function normalize(value) {
    return String(value || '').trim().toUpperCase();
  }

  function padCount(value) {
    return String(Math.max(0, Number(value) || 0)).padStart(2, '0');
  }

  function toNumber(value) {
    return Number(value) || 0;
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(value || '').trim());
  }

  function isValidPhone(value) {
    var digits = String(value || '').replace(/\D/g, '');
    return digits.length >= 7 && digits.length <= 15;
  }

  function buildRewardLookup(rewards) {
    var map = {};
    (rewards || []).forEach(function (reward) {
      if (reward && reward.id != null) {
        map[String(reward.id)] = reward;
      }
    });
    return map;
  }

  function getCachedRewards(cacheKey) {
    try {
      var raw = localStorage.getItem(cacheKey);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      return (parsed && Array.isArray(parsed.rewards)) ? parsed.rewards : null;
    } catch (e) {
      return null;
    }
  }

  function setCachedRewards(cacheKey, rewards) {
    try {
      localStorage.setItem(cacheKey, JSON.stringify({ rewards: rewards, ts: Date.now() }));
    } catch (e) {
      /* storage unavailable or full — ignore */
    }
  }

  function apiGet(params) {
    var url = new URL(params.apiUrl);
    Object.keys(params.query || {}).forEach(function (key) {
      if (params.query[key] != null && params.query[key] !== '') {
        url.searchParams.set(key, params.query[key]);
      }
    });

    return fetch(url.toString()).then(function (response) {
      if (!response.ok) {
        throw new Error('API request failed');
      }
      return response.json();
    });
  }

  function apiPost(apiUrl, payload) {
    return fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('API request failed');
      }
      return response.json();
    }).catch(function () {
      var query = Object.assign({ action: 'submitClaim' }, payload);
      return apiGet({ apiUrl: apiUrl, query: query });
    });
  }

  function getLocalRewards(section) {
    var rows = section.querySelectorAll('.js-rewards-rows .claim-reward__table-row');
    var rewards = [];

    rows.forEach(function (row) {
      var qtyCell = row.querySelector('.js-row-qty');
      var claimedCell = row.querySelector('.js-row-claimed-count');
      var redemptionCell = row.querySelector('.claim-reward__cell-redemption');

      rewards.push({
        id: row.getAttribute('data-reward-id') || (redemptionCell && redemptionCell.textContent.trim()),
        qty: qtyCell ? qtyCell.textContent.trim() : '0',
        redemption: redemptionCell ? redemptionCell.textContent.trim() : '',
        claimed: claimedCell ? claimedCell.textContent.trim() : '0'
      });
    });

    return rewards;
  }

  function spawnConfetti(container) {
    if (!container) return;

    container.innerHTML = '';
    var colors = ['#fbcf29', '#f26352', '#486ced', '#65daa1', '#ffffff', '#231f20'];

    for (var i = 0; i < 36; i++) {
      var piece = document.createElement('span');
      piece.className = 'claim-reward__confetti-piece';
      piece.style.left = Math.random() * 100 + '%';
      piece.style.backgroundColor = colors[i % colors.length];
      piece.style.animationDelay = (Math.random() * 0.8) + 's';
      piece.style.animationDuration = (2.2 + Math.random() * 1.4) + 's';
      container.appendChild(piece);
    }
  }

  function initCardSlides(section) {
    var slidesWrap = section.querySelector('.js-card-slides');
    if (!slidesWrap) return;

    var slides = slidesWrap.querySelectorAll('.claim-reward__card-slide');
    if (slides.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var interval = Number(slidesWrap.getAttribute('data-interval')) || 3000;
    var activeIndex = 0;

    setInterval(function () {
      slides[activeIndex].classList.remove('is-active');
      activeIndex = (activeIndex + 1) % slides.length;
      slides[activeIndex].classList.add('is-active');
    }, interval);
  }

  function initCardVideo(section) {
    var video = section.querySelector('.js-card-video');
    if (!video) return;

    var poster = section.querySelector('.js-card-video-poster');

    // Swap to a static poster when autoplay is refused (e.g. Low Power Mode) or motion is reduced,
    // so Safari's paused-video overlay never shows.
    function showPoster() {
      video.pause();
      if (!poster) return;
      video.hidden = true;
      poster.hidden = false;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      showPoster();
      return;
    }

    var playPromise = video.play();
    if (playPromise) {
      playPromise.catch(function (error) {
        if (error && error.name === 'NotAllowedError') showPoster();
      });
    }
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.claim-reward');
    if (section) initCardVideo(section);
  });

  function init() {
    var sections = document.querySelectorAll('.claim-reward');

    sections.forEach(function (section) {
      var customerId = section.getAttribute('data-customer-id') || '';
      var apiUrl = section.getAttribute('data-api-url') || window.__claimRewardApiUrl || DEFAULT_API_URL;
      var cacheKey = 'claim_reward_cache_' + (section.getAttribute('data-section-id') || '');
      var codePattern = null;
      var invalidCodeMessage = section.getAttribute('data-invalid-message') || 'Invalid code. Please try again.';

      try {
        var codePatternSource = section.getAttribute('data-code-pattern');
        if (codePatternSource) codePattern = new RegExp(codePatternSource);
      } catch (e) {
        codePattern = null;
      }

      if (!customerId) {
        try {
          customerId = localStorage.getItem('claim_reward_uuid');
          if (!customerId) {
            customerId = 'guest_' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
            localStorage.setItem('claim_reward_uuid', customerId);
          }
        } catch (e) {
          customerId = 'guest_anonymous';
        }
      }

      var form = section.querySelector('.js-claim-form');
      var input = section.querySelector('.js-claim-input');
      var submitBtn = section.querySelector('.js-claim-submit');
      var feedbackSuccess = section.querySelector('.js-feedback-success');
      var feedbackError = section.querySelector('.js-feedback-error');
      var rowsWrap = section.querySelector('.js-rewards-rows');
      var footerQtyCell = section.querySelector('.js-footer-qty');
      var footerClaimedCell = section.querySelector('.js-footer-claimed');
      var modal = section.querySelector('.js-claim-modal');
      var modalPanel = section.querySelector('.js-modal-panel');
      var modalConfetti = section.querySelector('.js-modal-confetti');
      var stepReveal = section.querySelector('.js-modal-step-reveal');
      var stepForm = section.querySelector('.js-modal-step-form');
      var stepSuccess = section.querySelector('.js-modal-step-success');
      var revealFrame = section.querySelector('.js-reveal-frame');
      var revealBadge = section.querySelector('.js-reveal-badge');
      var revealHeadline = section.querySelector('.js-reveal-headline');
      var revealBody = section.querySelector('.js-reveal-body');
      var revealClaimBtn = section.querySelector('.js-reveal-claim-btn');
      var claimDetailsForm = section.querySelector('.js-claim-details-form');
      var parentEmailInput = section.querySelector('.js-field-parent-email');
      var parentPhoneInput = section.querySelector('.js-field-parent-phone');
      var formSizes = section.querySelector('.js-form-sizes');
      var addressFields = section.querySelectorAll('.js-address-field');
      var formError = section.querySelector('.js-form-error');
      var formBackBtn = section.querySelector('.js-form-back');
      var formSubmitBtn = section.querySelector('.js-form-submit');
      var successMessage = section.querySelector('.js-success-message');
      var modalCloseBtns = section.querySelectorAll('.js-modal-close');
      var cardImage = section.querySelector('.js-card-image');
      var cardLabel = section.querySelector('.js-card-label');
      var defaultCardImageSrc = cardImage && cardImage.getAttribute('src');

      var state = {
        rewards: [],
        rewardById: {},
        activeCode: '',
        activePrize: null
      };

      var feedbackTimeout;
      var confettiTimeout;
      var entranceTimer;

      function showFeedback(element, text) {
        if (feedbackTimeout) clearTimeout(feedbackTimeout);
        if (feedbackSuccess) feedbackSuccess.style.display = 'none';
        if (feedbackError) feedbackError.style.display = 'none';

        if (element && text) {
          element.textContent = text;
          element.style.display = 'block';
          feedbackTimeout = setTimeout(function () {
            element.style.display = 'none';
          }, 4000);
        }
      }

      function setBusy(isBusy) {
        if (submitBtn) submitBtn.disabled = isBusy;
        if (input) input.disabled = isBusy;

        var loader = submitBtn && submitBtn.querySelector('.claim-reward__submit-btn-loader');
        var text = submitBtn && submitBtn.querySelector('.claim-reward__submit-btn-text');

        if (loader && text) {
          loader.classList.toggle('is-visible', isBusy);
          text.hidden = isBusy;
        }
      }

      function setFormBusy(isBusy) {
        if (formSubmitBtn) formSubmitBtn.disabled = isBusy;
        var loader = formSubmitBtn && formSubmitBtn.querySelector('.claim-reward__form-submit-loader');
        var text = formSubmitBtn && formSubmitBtn.querySelector('.claim-reward__form-submit-text');
        if (loader && text) {
          loader.hidden = !isBusy;
          text.hidden = isBusy;
        }
      }

      function showModalStep(step) {
        if (stepReveal) stepReveal.hidden = step !== 'reveal';
        if (stepForm) stepForm.hidden = step !== 'form';
        if (stepSuccess) stepSuccess.hidden = step !== 'success';
        if (modalPanel) {
          modalPanel.classList.toggle('claim-reward__modal-panel--reveal', step === 'reveal');
        }
      }

      function stopRevealEntrance() {
        if (confettiTimeout) {
          clearTimeout(confettiTimeout);
          confettiTimeout = null;
        }
        if (entranceTimer) {
          clearTimeout(entranceTimer);
          entranceTimer = null;
        }
        if (modal) modal.classList.remove('claim-reward__modal--entering');
        if (revealFrame) revealFrame.classList.remove('is-entering');
        if (modalConfetti) modalConfetti.innerHTML = '';
      }

      function playRevealEntrance() {
        if (!modal || !revealFrame) return;

        if (confettiTimeout) {
          clearTimeout(confettiTimeout);
          confettiTimeout = null;
        }
        if (entranceTimer) {
          clearTimeout(entranceTimer);
          entranceTimer = null;
        }
        if (modalConfetti) modalConfetti.innerHTML = '';

        modal.classList.remove('claim-reward__modal--entering');
        revealFrame.classList.remove('is-entering');
        void revealFrame.offsetWidth;
        modal.classList.add('claim-reward__modal--entering');
        revealFrame.classList.add('is-entering');

        confettiTimeout = setTimeout(function () {
          spawnConfetti(modalConfetti);
        }, 420);

        entranceTimer = setTimeout(function () {
          if (modal) modal.classList.remove('claim-reward__modal--entering');
        }, 1100);
      }

      function lockPageScroll() {
        document.documentElement.classList.add('claim-reward-modal-open');
      }

      function unlockPageScroll() {
        document.documentElement.classList.remove('claim-reward-modal-open');
      }

      function closeModal() {
        if (!modal) return;
        stopRevealEntrance();
        modal.style.display = 'none';
        modal.setAttribute('aria-hidden', 'true');
        unlockPageScroll();
        state.activeCode = '';
        state.activePrize = null;
        setFormBusy(false);
        if (claimDetailsForm) claimDetailsForm.reset();
        if (parentEmailInput) parentEmailInput.setAttribute('aria-invalid', 'false');
        if (parentPhoneInput) parentPhoneInput.setAttribute('aria-invalid', 'false');
        if (formError) {
          formError.hidden = true;
          formError.textContent = '';
        }
      }

      function openModal(step) {
        if (!modal) return;
        if (step !== 'reveal') stopRevealEntrance();
        showModalStep(step);
        modal.style.display = 'flex';
        modal.setAttribute('aria-hidden', 'false');
        lockPageScroll();
      }

      function populateReveal(prize) {
        if (revealBadge) revealBadge.textContent = prize.rarityLabel || 'SUPER RARE • SIGNED';
        if (revealHeadline) revealHeadline.textContent = prize.headline || prize.prizeName || 'YOU WON!';
        // Figma body only — never show the sheet CTA line ("Have a parent…")
        if (revealBody) revealBody.textContent = prize.body || '';

        if (revealFrame) {
          revealFrame.classList.toggle('claim-reward__reveal-frame--grand', !!prize.grandPrize);
        }

        if (formSizes) formSizes.hidden = !prize.requiresSizes;

        if (cardLabel) cardLabel.textContent = prize.prizeName || 'Super Rare Prize';
        if (cardImage && defaultCardImageSrc) {
          cardImage.src = defaultCardImageSrc;
        }
      }

      function configureFormRequirements(prize) {
        var sizeFields = formSizes ? formSizes.querySelectorAll('select') : [];
        sizeFields.forEach(function (field) {
          field.required = !!prize.requiresSizes;
        });

        // Only an explicit false hides the address; older API versions keep it required.
        var hideAddress = prize.addressRequired === false;
        addressFields.forEach(function (field) {
          field.hidden = hideAddress;
          var control = field.querySelector('input');
          if (!control) return;
          if (hideAddress) {
            control.required = false;
            control.value = '';
          } else if (field.hasAttribute('data-required')) {
            control.required = true;
          }
        });
      }

      function renderTable(rewards) {
        if (!rowsWrap) return;

        rowsWrap.innerHTML = '';

        var totalQty = 0;
        var totalClaimed = 0;

        (rewards || []).forEach(function (reward) {
          var qty = toNumber(reward.qty);
          var claimed = toNumber(reward.claimed);
          var progress = qty > 0 ? (claimed / qty) * 100 : 0;

          totalQty += qty;
          totalClaimed += claimed;

          var row = document.createElement('div');
          row.className = 'claim-reward__table-row';
          row.setAttribute('role', 'row');
          row.setAttribute('data-reward-id', String(reward.id || ''));

          row.innerHTML = [
            '<div class="claim-reward__cell-qty js-row-qty" role="cell">', padCount(qty), '</div>',
            '<div class="claim-reward__cell-redemption" role="cell">', (reward.redemption || ''), '</div>',
            '<div class="claim-reward__cell-claimed" role="cell">',
            '<span class="claim-reward__claimed-count js-row-claimed-count">', padCount(claimed), '</span>',
            '<div class="claim-reward__progress-bar">',
            '<div class="claim-reward__progress-bar-fill js-row-progress-fill" style="width: 0%;" data-progress="', progress, '"></div>',
            '</div>',
            '</div>'
          ].join('');

          rowsWrap.appendChild(row);
        });

        setTimeout(function () {
          var fills = rowsWrap.querySelectorAll('.js-row-progress-fill');
          fills.forEach(function (fill) {
            fill.style.width = fill.getAttribute('data-progress') + '%';
          });
        }, 50);

        if (footerQtyCell) footerQtyCell.textContent = String(totalQty);
        if (footerClaimedCell) footerClaimedCell.textContent = padCount(totalClaimed) + '/' + String(totalQty);
      }

      function syncRewardRow(rewardId, claimed) {
        var row = rowsWrap && rowsWrap.querySelector('[data-reward-id="' + rewardId + '"]');
        var reward = state.rewardById[rewardId];
        if (!row || !reward) return;

        if (claimed != null) reward.claimed = toNumber(claimed);

        var qty = toNumber(reward.qty);
        var claimedCount = toNumber(reward.claimed);
        var qtyCell = row.querySelector('.js-row-qty');
        var claimedCell = row.querySelector('.js-row-claimed-count');
        var progressFill = row.querySelector('.js-row-progress-fill');

        if (qtyCell) qtyCell.textContent = padCount(qty);
        if (claimedCell) claimedCell.textContent = padCount(claimedCount);
        if (progressFill) progressFill.style.width = qty > 0 ? ((claimedCount / qty) * 100) + '%' : '0%';

        var totalQty = 0;
        var totalClaimed = 0;
        state.rewards.forEach(function (item) {
          totalQty += toNumber(item.qty);
          totalClaimed += toNumber(item.claimed);
        });
        if (footerQtyCell) footerQtyCell.textContent = String(totalQty);
        if (footerClaimedCell) footerClaimedCell.textContent = padCount(totalClaimed) + '/' + String(totalQty);
      }

      function loadRewards() {
        var cachedRewards = getCachedRewards(cacheKey);
        if (cachedRewards) {
          state.rewards = cachedRewards;
          state.rewardById = buildRewardLookup(state.rewards);
          renderTable(state.rewards);
        }

        if (!apiUrl) {
          if (!cachedRewards) {
            state.rewards = getLocalRewards(section);
            state.rewardById = buildRewardLookup(state.rewards);
            renderTable(state.rewards);
          }
          return Promise.resolve();
        }

        return apiGet({ apiUrl: apiUrl, query: { action: 'rewards' } }).then(function (data) {
          if (data && Array.isArray(data.rewards)) {
            state.rewards = data.rewards.slice();
            state.rewardById = buildRewardLookup(state.rewards);
            renderTable(state.rewards);
            setCachedRewards(cacheKey, state.rewards);
          } else if (!cachedRewards) {
            state.rewards = getLocalRewards(section);
            state.rewardById = buildRewardLookup(state.rewards);
            renderTable(state.rewards);
          }
        }).catch(function (error) {
          console.error(error);
          if (!cachedRewards) {
            state.rewards = getLocalRewards(section);
            state.rewardById = buildRewardLookup(state.rewards);
            renderTable(state.rewards);
          }
        });
      }

      modalCloseBtns.forEach(function (btn) {
        btn.addEventListener('click', closeModal);
      });

      if (revealClaimBtn) {
        revealClaimBtn.addEventListener('click', function () {
          if (!state.activePrize) return;
          configureFormRequirements(state.activePrize);
          openModal('form');
        });
      }

      if (formBackBtn) {
        formBackBtn.addEventListener('click', function () {
          openModal('reveal');
        });
      }

      if (input) {
        input.addEventListener('input', function () {
          if (!input.value.trim()) {
            if (feedbackTimeout) clearTimeout(feedbackTimeout);
            if (feedbackSuccess) feedbackSuccess.style.display = 'none';
            if (feedbackError) feedbackError.style.display = 'none';
          }
        });
      }

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();

          var enteredCode = normalize(input && input.value);
          if (!enteredCode) {
            showFeedback(feedbackError, 'Please enter a code.');
            return;
          }

          // Same message as an unknown code, so the expected format is not revealed.
          if (codePattern && !codePattern.test(enteredCode)) {
            showFeedback(feedbackError, invalidCodeMessage);
            return;
          }

          if (!apiUrl) {
            showFeedback(feedbackError, 'Claim service is not configured.');
            return;
          }

          setBusy(true);
          apiGet({ apiUrl: apiUrl, query: { action: 'lookup', code: enteredCode } }).then(function (response) {
            if (response && Array.isArray(response.cards) && response.outcome == null) {
              showFeedback(
                feedbackError,
                'The claim API is running an old version. Redeploy the updated Apps Script (lookup action) and try again.'
              );
              return;
            }

            if (response && response.success && response.outcome === 'winner' && response.prize) {
              state.activeCode = enteredCode;
              state.activePrize = response.prize;
              populateReveal(response.prize);
              playRevealEntrance();
              openModal('reveal');
              if (input) input.value = '';
              return;
            }

            if (response && response.outcome === 'already_claimed' && response.message) {
              showFeedback(feedbackError, response.message);
              return;
            }

            if (response && response.outcome === 'sold_out' && response.message) {
              showFeedback(feedbackError, response.message);
              return;
            }

            showFeedback(
              feedbackError,
              (response && response.message) || 'Invalid code. Please try again.'
            );
          }).catch(function (error) {
            console.error(error);
            showFeedback(feedbackError, 'Could not verify code. Please try again.');
          }).finally(function () {
            setBusy(false);
          });
        });
      }

      function showFormError(message, field) {
        if (parentEmailInput) parentEmailInput.setAttribute('aria-invalid', 'false');
        if (parentPhoneInput) parentPhoneInput.setAttribute('aria-invalid', 'false');
        if (field) {
          field.setAttribute('aria-invalid', 'true');
          field.focus();
        }
        if (formError) {
          formError.textContent = message;
          formError.hidden = false;
        }
      }

      if (parentEmailInput) {
        parentEmailInput.addEventListener('input', function () {
          parentEmailInput.setAttribute('aria-invalid', 'false');
        });
      }

      if (parentPhoneInput) {
        parentPhoneInput.addEventListener('input', function () {
          parentPhoneInput.setAttribute('aria-invalid', 'false');
        });
      }

      if (claimDetailsForm) {
        claimDetailsForm.addEventListener('submit', function (e) {
          e.preventDefault();
          if (!state.activeCode || !state.activePrize) return;

          if (formError) {
            formError.hidden = true;
            formError.textContent = '';
          }

          var formData = new FormData(claimDetailsForm);
          var parentEmail = String(formData.get('parentEmail') || '').trim();
          var parentPhone = String(formData.get('parentPhone') || '').trim();

          if (!isValidEmail(parentEmail)) {
            showFormError('Please enter a valid email address.', parentEmailInput);
            return;
          }

          if (!isValidPhone(parentPhone)) {
            showFormError('Please enter a valid phone number.', parentPhoneInput);
            return;
          }
          var payload = {
            action: 'submitClaim',
            code: state.activeCode,
            customerId: customerId,
            parentName: formData.get('parentName'),
            parentEmail: parentEmail,
            parentPhone: parentPhone,
            consent: formData.get('consent') ? 'true' : 'false',
            address1: formData.get('address1'),
            address2: formData.get('address2'),
            city: formData.get('city'),
            state: formData.get('state'),
            zip: formData.get('zip'),
            country: formData.get('country') || 'US',
            shirtSize: formData.get('shirtSize'),
            hoodieSize: formData.get('hoodieSize'),
            hatSize: formData.get('hatSize')
          };

          setFormBusy(true);
          apiPost(apiUrl, payload).then(function (response) {
            if (response && response.success) {
              if (successMessage) {
                successMessage.textContent = response.message || 'Our team will reach out within 48 hours.';
              }
              syncRewardRow(String(response.rewardId || state.activePrize.rewardId), response.claimed);
              openModal('success');
              showFeedback(feedbackSuccess, response.message || 'Claim submitted!');
            } else if (formError) {
              formError.textContent = (response && response.message) || 'Could not submit claim.';
              formError.hidden = false;
            }
          }).catch(function (error) {
            console.error(error);
            if (formError) {
              formError.textContent = 'Could not submit claim. Please try again.';
              formError.hidden = false;
            }
          }).finally(function () {
            setFormBusy(false);
          });
        });
      }

      initCardSlides(section);
      initCardVideo(section);
      loadRewards();
    });
  }

  init();
})();
